import { setSkin } from "@/utils/skin";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        component: resolve => require(["@/view/home/index.vue"], resolve),
        meta: {
            title: "后天俱乐部",
            content: "后天俱乐部是专业的 CS2 中文网站，提供最新的反恐精英2 更新日志、教程攻略、控制台指令、创意工坊推荐、cs导航等内容。" 
        }
    },

    // {
    //     path: '/panel1',
    //     component:  resolve => require(["@/view/workshop/workshop.vue"], resolve),
    //     name: 'Panel1',
    //     meta: { tabName: 'workshop', title: '创意工坊' }
    //   },
      {
        path: '/updatenotes',
        component:  resolve => require(["@/view/updatenotes/index.vue"], resolve),
        name: 'updatenotes',
        meta: { tabName: 'updatenotes', 
            title: 'CS2更新日志',
            meta: {
                title: "更新日志",
                description: "查看最新的CS2游戏更新日志，了解每次更新带来的新功能和改进。",
            }
        
        }
      },
      {
        path: '/command',
        component:  resolve => require(["@/view/command/index.vue"], resolve),
        name: 'command',
        meta: { tabName: 'command',title: 'CS2指令', content: "收录CS2中最全的指令，帮助你快速上手。" }
      },


    {

        path: "/workshop",
        component: resolve => require(["@/view/workshop/index.vue"], resolve),
        meta: {
            title: "创意工坊",
            description: "创意工坊，汇集cs好玩，实用的创意工坊！",
        }
    },
    {

        path: "/links",
        component: resolve => require(["@/view/link/index.vue"], resolve),
        meta: {
            title: "友情链接"
        }
    },
    {
        path: "/articleInfo",
        component: resolve => require(["@/view/article/index.vue"], resolve),
        meta: {
            title: "文章详情"
        }
    },
    // {
    //     path: "/message",
    //     component: resolve => require(["@/view/message/index.vue"], resolve),
    //     meta: {
    //         title: "留言板"
    //     }
    // },
    {
        path: "/about",
        component: resolve => require(["@/view/about/index.vue"], resolve),
        meta: {
            title: "关于作者"
        }
    },
    // {
    //     path: "/news",
    //     component: resolve => require(["@/view/news/index.vue"], resolve),
    //     meta: {
    //         title: "更新日志",
    //         description: "查看最新的CS2游戏更新日志，了解每次更新带来的新功能和改进。",
    //     }
    // },
    {
        path: "/case",
        component: resolve => require(["@/view/case/index"], resolve),
        meta: {
            title: '武器箱大行动',
            description: "查看最新的武器箱，大行动，月活人数等数据",
            keywords: "武器箱, 大行动"
        }
    },
    {
        path: "/skinDatabase",
        component: resolve => require(["@/view/skinDatabase/index"], resolve),
        meta: {
            title: '皮肤数据库',
            description: "查看最新的皮肤数据库，了解最新的皮肤数据。",
            keywords: "皮肤数据库, 皮肤"
        }
    },
    
    {
        path: "/standings",
        name: 'standings',
        component: () => import('@/view/standings/index.vue'),
        meta: {
            title: 'v社排名',
            description: "查看V社排名，了解最新的职业比赛排名动态。",
        }
    },
    {
        path: "/valvestandings",
        name: 'valvestandings',
        component: () => import('@/view/standings/indexreal.vue'),
        meta: {
            title: 'v社排名',
            description: "查看V社排名，了解最新的职业比赛排名动态。",
        }
    },
    {
        path: "/sites",
        component: resolve => require(["@/view/navigationPage/index"], resolve),
        meta: {
            title: 'cs导航站',
         description: "通过我们的CS2游戏资源导航页面，快速访问与反恐精英2相关的各类资源、工具和论坛，帮助你提升游戏体验。",
        keywords: "CS2, 反恐精英2, CS2 资源, CS2 工具, CS2 下载, CS2 论坛, CS2 游戏网站"
        }
    },
    {
        path: "/search",
        component: resolve => require(["@/view/search/index"], resolve),
        meta: {
            title: "搜索文章"
        }
    },
    {
        path: "/archive",
        component: resolve => require(["@/view/archive/index"], resolve),
        meta: {
            title: "文章归档"
        }
    },
    {
        path: "/categorys",
        component: resolve => require(["@/view/category/Category"], resolve),
        meta: {
            title: "文章分类"
        }
    },
    {
        name: "/category",
        path: "/category",
        component: resolve => require(["@/view/category/index"], resolve),
    },
    {
        path: "/tag",
        component: resolve => require(["@/view/tag/Tag"], resolve),
    },
    {
        path: "/tags",
        name: "/tags",
        component: resolve => require(["@/view/tag/index"], resolve),
    },
    {
        path: "/photo",
        component: resolve => require(["@/view/photo/index"], resolve),
    },
    {
        path: "/sponsor",
        component: resolve => require(["@/view/sponsor/index"], resolve),
    },
    {
        path: "/user",
        component: resolve => require(["@/view/user/index"], resolve),
    },
    // {
    //     path: "/im",
    //     component: resolve => require(["@/view/im/index"], resolve),
    // },

    {
        path: "/callback/qq",
        component: resolve => require(["@/components/model/OauthLogin.vue"], resolve)
    },
    {
        path: "/callback/gitee",
        component: resolve => require(["@/components/model/OauthLogin.vue"], resolve)
    },
    {
        path: "/callback/weibo",
        component: resolve => require(["@/components/model/OauthLogin.vue"], resolve)
    },

    {
        path: "*",
        name: "NotFound",
        component: () => import("@/view/404/404.vue"),
    }
];

const router = new VueRouter({
    mode: "history",
    // mode: "hash",
    scrollBehavior: () => ({ y: 0 }),
    routes
});
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
    setSkin()

    next()
})
export default router;